import React from 'react';
import { AlertTriangle } from 'lucide-react';

export interface GroundingReviewFlag {
  field?: string;
  claim?: string;
  unsupported_terms?: string[];
}

export interface GroundingReview {
  message?: string;
  flags?: GroundingReviewFlag[];
}

export const formatFieldLabel = (key: string | undefined | null): string => {
  if (!key) return 'Statement';
  return key
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
    .trim();
};

export const GroundingReviewAlert = ({ review }: { review?: GroundingReview | null }) => {
  if (!review || !review.flags || review.flags.length === 0) return null;
  return (
    <div className="mb-4 p-4 rounded border-l-4 border-yellow-500 bg-yellow-50 dark:bg-yellow-900/20 text-yellow-900 dark:text-yellow-100">
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 shrink-0" size={20} />
        <div>
          <h3 className="text-sm font-semibold mb-1">AI review flag</h3>
          <p className="text-sm mb-2">
            {review.message || 'This note contains statements that may not be supported by the source material. Please review before signing.'}
          </p>
          <ul className="text-xs space-y-1 list-disc list-inside">
            {review.flags.map((flag, idx) => (
              <li key={idx}>
                <span className="font-medium">{flag.field ? formatFieldLabel(flag.field) : 'Statement'}:</span>{' '}
                {flag.claim}
                {flag.unsupported_terms && flag.unsupported_terms.length > 0 && (
                  <span className="text-yellow-700 dark:text-yellow-300">
                    {' '} (unverified: {flag.unsupported_terms.join(', ')})
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export const getFlaggedFieldKeys = (review?: GroundingReview | null): string[] => {
  if (!review || !review.flags) return [];
  return review.flags.map((f) => f.field).filter((f): f is string => Boolean(f));
};
